// extracted by mini-css-extract-plugin
export var wrapper = "ContentDump-module--wrapper--7ec75";